import { PATHS } from '@tom-ui/utils'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import YardHaul from './YardHaul'

export const YardHaulPage: FC = () => {
  const navigate = useNavigate()
  return <YardHaul onClose={() => navigate(PATHS.arcade.url)} />
}
